import { Component} from '@angular/core';
import { ActionSheetController, AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { ToastProvider } from '../../providers/toast/toast';
import { ExtraProvider } from '../../providers/extra/extra';
import { VehicleAccessLogPage } from '../vehicle-access-log/vehicle-access-log';
import { VehicleProvider } from '../../providers/vehicle/vehicle';
import { SmartLockProvider } from '../../providers/smart-lock/smart-lock';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-vehicle-tag',
  templateUrl: 'vehicle-tag.html',
})
export class VehicleTagPage {
  vehicle : any;
  setups : any;
  tagDetails : any;
  tag_response : any;
  parent : any

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private toast: ToastProvider,
    private vehicleProvider: VehicleProvider,
    public alertCtrl: AlertController
    ){
      this.vehicle = this.navParams.get("vehicle"); 
      this.parent = this.navParams.get("parent"); 
      this.setups = this.navParams.get("setups");
      this.tagDetails = {
        provider : this.vehicle.provider,
        rf_id : this.vehicle.rf_id,
        secret_code : this.vehicle.secret_code
      }
      if(this.vehicle.provider_response && this.vehicle.provider_response.service_response){
        this.tag_response = this.vehicle.provider_response.status + (this.vehicle.provider_response.service_response.message ?' : '+ this.vehicle.provider_response.service_response.message:"")
      }
    }

    selectProvider() {
      if(this.setups && this.setups.length>0){
        let alert = this.alertCtrl.create();
        alert.setTitle('Select Providers');

        this.setups.forEach(val => {
          alert.addInput({
            type: 'radio',
            label: val.service,
            value: val.service,
            checked: true
          });
          alert.addButton('Cancel');
          alert.addButton({
            text: 'OK',
            handler: data => {
              this.tagDetails.provider = data
            }
          });
          alert.present();
        })
      }else{
        const alert = this.alertCtrl.create({
          title: 'No Provider!',
          subTitle: 'Currently there are no providers configured. Kindly contact Admin',
          buttons: ['OK']
        });
        alert.present();
      }
    }

  addTag(){
    this.vehicle = Object.assign(this.vehicle, this.tagDetails)
    this.vehicleProvider.addVehicleTag(this.vehicle)
    .then(val => {
      this.tag_response = val.status+" : "+ val.message
      this.toast.presentToast(this.tag_response);
      if(val.status == "success"){
        this.parent.refresh()
        this.navCtrl.pop();
      }else{
      }
    });
  }

  removeTag(){
    this.vehicle = Object.assign(this.vehicle, this.tagDetails)
    this.vehicleProvider.removeVehicleTag(this.vehicle)
    .then(val => {
      this.parent.refresh()
      // if(val.status == "success"){
        this.navCtrl.pop();
      // }else{
        // this.toast.presentToast(val.message);
      // }
    });
  }

  toastData(data){
    this.toast.presentToast(data);
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad VehicleTagPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/vehicle-tag/vehicle-tag.ts